module.exports = __webpack_public_path__ + "img/3.b522f297.jpg";